module.exports = __webpack_public_path__ + "img/Травмы, растяжения.c4a3fc79.jpg";